import { breakpoints } from '@eversports/design-tokens/breakpoints'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import * as React from 'react'

const ContainedXLWidthContainer = ({ children }: React.PropsWithChildren<unknown>) => (
  <Stack display="block" width="100%" maxWidth={breakpoints.xl} mx="auto" zIndex="1">
    {children}
  </Stack>
)

export default ContainedXLWidthContainer
